import React, { ComponentProps, ReactNode } from 'react'

import { bemJoin } from 'bem-join'

import { classNames } from '@app/lib/bem'
import { MergeProps } from '@app/lib/types'

import './LineItem.scss'

export type LineItemProps = MergeProps<
  ComponentProps<'div'>,
  {
    icon?: ReactNode
    label?: ReactNode
    actions?: ReactNode
  }
>

const b = bemJoin('line-item')

export const LineItem = ({ icon, label, actions, className, ...rest }: LineItemProps) => {
  return (
    <div className={classNames(b(), className)} {...rest}>
      {icon && <div className={b('icon')}>{icon}</div>}
      {label && <div className={b('label')}>{label}</div>}
      {actions && <div className={b('actions')}>{actions}</div>}
    </div>
  )
}
